var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIfaks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 155.68,
    y1: 197.12,
    x2: 12.05,
    y2: 46.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babd42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82954b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 132.71,
    y1: 177.23,
    x2: 60.32,
    y2: 87.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 174.61,
    y1: 179.02,
    x2: 30.98,
    y2: 28.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 194.02,
    y1: 160.47,
    x2: 50.4,
    y2: 10.2,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.73,150.31c0,1.43,.13,2.83,.35,4.19-.6-.44-.98-.7-1.08-.76-6.7-4.83-10.35-11.47-10.35-18.74V46.01c0-10.93,8-20.23,19.06-22.1l44.08-7.53c6.32-1.08,12.77,.57,18.61,4.8,.16,.1,1.43,1.02,3.27,2.35-.54,.06-1.08,.13-1.65,.22l-50.66,7.91c-12.51,2.13-21.63,12.74-21.63,25.15v93.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.59,97.59c-.53-2.07-2.66-3.3-4.7-2.78l-10.46,2.69v-10.92c0-2.13-1.73-3.86-3.86-3.86s-3.86,1.73-3.86,3.86v12.9l-12.39,3.18c-2.07,.53-3.31,2.64-2.78,4.7,.45,1.74,2.02,2.9,3.74,2.9,.32,0,.64-.04,.96-.12l10.47-2.69v10.36c0,2.13,1.73,3.86,3.86,3.86s3.86-1.73,3.86-3.86v-12.34l12.38-3.18c2.07-.53,3.31-2.64,2.78-4.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.34,32.2c-5.84-4.22-12.26-5.88-18.61-4.8l-41.67,7.11c-.5-.35-1.18-.82-1.98-1.4-2.54-1.82-5.47-3.18-8.58-3.49-.67-.07-1.34-.1-2.02-.1-1.14,0-2.32,.1-3.49,.32l-50.62,7.91c-9.53,1.62-16.45,9.65-16.45,19.06v93.5c0,3.87,1.21,7.65,3.43,10.8,4.54,3.27,8.99,6.45,9.31,6.67l.06,.06c.41,.35,.86,.67,1.3,.95,3.91,2.67,8.51,4.13,13.24,4.13h.06c.98,0,2-.1,2.99-.22,.32-.06,.64-.06,.95-.13l41.67-7.11,.16,.1s0-.1-.03-.13c-.22-1.37-.35-2.7-.35-4.1V67.83c0-8.89,4.64-16.8,11.85-21.37,2.13-1.37,4.51-2.45,7.05-3.14,.89-.25,1.81-.48,2.73-.64l50.62-7.91c.57-.1,1.11-.16,1.68-.22l-3.3-2.35ZM51.96,164.95c-4.6,.79-9.27-.44-12.77-3.43-3.33-2.79-5.24-6.83-5.24-11.08V61.48c0-7.18,5.34-13.28,12.64-14.51l44.08-7.53c.67-.13,1.3-.19,1.94-.19-5.56,4.1-9.02,10.58-9.02,17.79v88.99c0,4.64,1.49,8.99,4.29,12.8l-35.92,6.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.36,64.97v88.96c0,10.93-8,20.23-19.06,22.14l-44.08,7.53c-1.3,.22-2.64,.35-3.94,.35-4.99,0-9.91-1.72-14.67-5.15-.32-.25-4.73-3.4-9.31-6.64,0,0,0-.03-.03-.03-1.68-2.41-2.76-5.18-3.21-8.07-.13-.89-.19-1.81-.19-2.73V67.83c0-6.16,2.99-11.75,7.72-15.31,2.1-1.59,4.57-2.76,7.27-3.43,.48-.13,.95-.22,1.46-.32l50.66-7.91c1.14-.22,2.32-.32,3.46-.32,2.7,0,5.37,.54,7.81,1.59,3.08,2.19,5.53,3.94,5.75,4.1,6.86,4.95,10.35,11.24,10.35,18.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170.56,108.61c-.53-2.07-2.66-3.3-4.7-2.78l-10.47,2.69v-10.92c0-2.13-1.73-3.86-3.86-3.86s-3.86,1.73-3.86,3.86v12.9l-12.39,3.18c-2.07,.53-3.31,2.64-2.78,4.7,.45,1.74,2.02,2.9,3.74,2.9,.32,0,.64-.04,.96-.12l10.47-2.69v10.36c0,2.13,1.73,3.86,3.86,3.86s3.86-1.73,3.86-3.86v-12.34l12.38-3.18c2.07-.53,3.31-2.64,2.78-4.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIfaks);
export default __webpack_public_path__ + "static/media/icon-ifaks.bef376e1dbd07371c55078118fddec49.svg";
export { ForwardRef as ReactComponent };